<template>
  <v-app>
    <!-- Maintenance Page -->
    <v-container v-if="maintenanceMode" fill-height fluid class="maintenance-page">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="pa-8 text-center" elevation="4">
            <div class="mb-6">
              <img
                src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
                alt="HEIG-VD"
                class="maintenance-logo"
              />
            </div>
            <h1 class="text-h4 mb-4">Maintenance en cours</h1>
            <p class="text-body-1 grey--text text--darken-1 mb-6">
              Notre plateforme est actuellement en maintenance pour améliorer votre expérience.
              Nous serons de retour très bientôt.
            </p>
            <v-divider class="my-6"></v-divider>
            <p class="text-caption grey--text">
              Merci pour votre patience
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Normal App -->
    <template v-else>
      <v-app-bar app flat color="grey lighten-4">
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <user-profile />
      </v-app-bar>
      <v-navigation-drawer app v-model="drawer" overlay-opacity="0">
        <template v-slot:prepend>
          <v-list-item two-line>
            <v-list-item-avatar tile>
              <img
                src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>HR-IO</v-list-item-title>
              <v-list-item-subtitle>Interface de gestion</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <v-list dense nav>
          <v-list-item link to="/">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/hiring-notices">
            <v-list-item-icon>
              <v-icon>mdi-account-arrow-left-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Avis d'entrée</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/leaving-notices">
            <v-list-item-icon>
              <v-icon>mdi-account-arrow-right-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Avis de sortie</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/newsletters">
            <v-list-item-icon>
              <v-icon>mdi-newspaper-variant-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Newsletter</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main class="ma-md-10 ma-sm-0">
        <router-view />
      </v-main>
    </template>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";

export default {
  name: "App",
  components: { UserProfile },
  data: () => ({
    drawer: null,
    // Set to true to enable maintenance mode
    // Can also be controlled via environment variable VUE_APP_MAINTENANCE_MODE
    maintenanceMode: process.env.VUE_APP_MAINTENANCE_MODE === 'true' || false,
  }),
};
</script>

<style>
.separator {
  display: inline-block;
}

.maintenance-page {
  background: linear-gradient(135deg, #fb923c 0%, #fcd34d 100%);
  min-height: 100vh;
}

.maintenance-logo {
  max-width: 100px;
  height: auto;
}
</style>